export default __webpack_public_path__ + "assets/icon-refresh-black.c5eb5139.webp";